import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import React, { useState } from "react";
import { bhpButtonSx } from "../../../styles/bhpStyles";


type EnterAuditDialogProps = {

    dialogOpen: boolean;
    handleCancel: ( ) => void;
    handleOk: ( auditText : string ) => void;

};


export const EnterAuditDialog : React.FC< EnterAuditDialogProps > = ( props : EnterAuditDialogProps) => {

    const { dialogOpen, handleCancel, handleOk } = props;

    const [ auditText, setAuditText ] = useState< string >( '' );


    const handleAuditTextChange = ( event: React.ChangeEvent<HTMLInputElement> ) => setAuditText( event.target.value );


    const handleAuditTextKeyPress = async ( event: React.KeyboardEvent<HTMLDivElement> ) => {

        if( auditText.length === 0 || event.key !== 'Enter' ) {
            
            return;

        }

        handleOk( auditText );
        setAuditText( '' );

    };

    const handleCancelClick = () => {

        handleCancel( );
        setAuditText( '' );

    };
    
    
    const handleOkClick = () => {

        handleOk( auditText );
        setAuditText( '' );

    };

    return(

        <Dialog
            sx={{ '& .MuiDialog-paper': { maxHeight: 435, width: '500px' } }}
            open={dialogOpen}>
            <DialogTitle>Enter Audit Comments</DialogTitle>
            <DialogContent dividers>
                
                <TextField 
                    sx={{ width: '100%' }}
                    multiline
                    rows={4}
                    label="Audit"
                    variant="outlined"
                    value={ auditText }
                    onChange={ handleAuditTextChange }
                    onKeyPress={ handleAuditTextKeyPress }
                />
                

            </DialogContent>
            <DialogActions>
                <Button onClick={ handleOkClick } sx={{ ...bhpButtonSx, width: '100px' }} disabled={ auditText.length === 0 }>
                    Ok
                </Button>
                <Button autoFocus onClick={ handleCancelClick } sx={{ ...bhpButtonSx, width: '100px' }}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>

    );
    
};